import React from "react";
import arrowIcon from "../../../images/arrow-right-green.svg";
import { sendToUrl } from "../../../utilities";

/*

* React FC
  
*/

const TopFunds = ({ topTaxFunds }) => {
  return (
    <>
      <div className="flex space-between spacer_sm ">
        <span className="para-1-bold bold ">Top ELSS Funds</span>
        <a
          className="para-2 bold text-secondary"
          href={sendToUrl(`https://www.piggy.co.in/best-mutual-funds/`)}
        >
          View All Funds
        </a>
      </div>
      {topTaxFunds.map(({ scheme: { details } }, ind) => (
        <a
          className="flex-row pointer rounded border-1 space-between align-center spacer_sm topFundCard"
          key={ind}
          href={sendToUrl(
            `https://www.piggy.co.in/mutual-funds/direct/${details.url_name}/`
          )}
        >
          <div className="topFundDiv">
            <span className="para-3-bold bold topFundCardName">{details.name}</span>
            <div className="flex" style={{ marginTop: "8px" }}>
              <div className="para-4 riskLabel">
                <span style={{ fontFamily: "Hind Madurai" }}>3Yr. Ret.</span>
                <span className="para-4 bold align-center riskValue">
                  {details.return_3yr}%
                </span>
              </div>
              <div className="para-4 riskLabel">
                <span style={{ fontFamily: "Hind Madurai" }}>5Yr. Ret.</span>
                <span className="para-4 bold align-center riskValue">
                  {details.return_5yr}%
                </span>
              </div>
            </div>
          </div>
          <img src={arrowIcon} alt="View Fund" />
        </a>
      ))}
      <style jsx> {
        `.topFundCard{
          padding:16px;
        }
        .topFundCard:hover > .topFundDiv > .topFundCardName {
          color: #4dc3b6;
        }
        
        .topFundCard:hover {
          background-color: rgba(77, 195, 182, 0.05);
        }
        .riskLabel{
          margin-left:5px;
        }
        .riskValue{
          margin:0 16px 0 8px;
          color: #4dc3b6;
        }
      
      `}</style>
    </>
  );
};

export default TopFunds;
